// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"358":"231038e4c8f338bf","888":"482fe70354e5bdfc"}[chunkId] + ".css";
};